import { render, staticRenderFns } from "./ExportOverzichtList.vue?vue&type=template&id=28d3ec80"
import script from "./ExportOverzichtList.vue?vue&type=script&lang=js"
export * from "./ExportOverzichtList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports